import {
  MAX_USER_PASSWORD_LENGTH,
  MIN_USER_PASSWORD_LENGTH,
  securePasswordRegex,
} from '@ipfabric/utils';
import type { FormikErrors } from 'formik';
import type { UpdatePasswordFormValues } from 'pages/Settings/Administration/LocalUsers/UpdatePasswordForm';
import type { AppTranslations } from 'translations/translations';

export const validateUserPassword = (
  values: UpdatePasswordFormValues,
  errors: FormikErrors<UpdatePasswordFormValues>,
  validationsMsg: AppTranslations['localUsers']['form']['validations'],
): void => {
  if (!values.newPassword) {
    errors.newPassword = validationsMsg.required;
  } else if (values.newPassword.length < MIN_USER_PASSWORD_LENGTH) {
    errors.newPassword = validationsMsg.passwordMinLength;
  } else if (!securePasswordRegex.test(values.newPassword)) {
    errors.newPassword = validationsMsg.passwordComplexity;
  } else if (values.newPassword.length > MAX_USER_PASSWORD_LENGTH) {
    errors.newPassword = validationsMsg.passwordMaxLength;
  } else if (values.newPassword !== values.retypePassword) {
    errors.retypePassword = validationsMsg.matchPasswords;
  }
};
